<div id="logo-container">
    <div id="subtitle">powered by</div>
    <a id="img-container" href="https://famigo.info" target="_blank">
        <img src="assets/famigo_logo.png" alt="famigo">
    </a>
</div>
